import { type ReactNode, useCallback, useMemo } from 'react';
import { router, usePage } from '@inertiajs/react';
import { NavigationContext } from '@/hooks/use-navigation';

export function InertiaNavigationProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { url } = usePage();
  const navigate = useCallback((path: string) => router.visit(path), []);

  const value = useMemo(() => ({ navigate, pathname: url }), [navigate, url]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}
